import { render, staticRenderFns } from "./SurveyTabularView.vue?vue&type=template&id=36c36861&scoped=true"
import script from "./SurveyTabularView.vue?vue&type=script&lang=js"
export * from "./SurveyTabularView.vue?vue&type=script&lang=js"
import style0 from "./SurveyTabularView.vue?vue&type=style&index=0&id=36c36861&prod&scoped=true&lang=css"
import style1 from "./SurveyTabularView.vue?vue&type=style&index=1&id=36c36861&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c36861",
  null
  
)

export default component.exports